(() => {
  const normalize = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-bpr-category-search-root]').forEach(root => {
      if (root.dataset.categorySearchReady) return;
      root.dataset.categorySearchReady = 'true';
      const input = root.querySelector('[data-bpr-category-search]');
      const clear = root.querySelector('[data-bpr-category-clear]');
      const empty = root.querySelector('[data-bpr-category-no-results]');
      const groups = Array.from(root.querySelectorAll('[data-bpr-category-group]'));
      const azItems = Array.from(root.querySelectorAll('[data-bpr-category-az-item]'));
      const originalStates = new Map(groups.filter(group => group.tagName === 'DETAILS').map(group => [group, group.open]));
      const matches = (label, terms) => terms.every(term => normalize(label).includes(term));
      const filter = () => {
        const query = normalize(input.value);
        const terms = query.split(' ').filter(Boolean);
        let visible = 0;
        groups.forEach(group => {
          const groupMatches = matches(group.dataset.searchLabel || '', terms);
          let childMatches = 0;
          group.querySelectorAll('[data-bpr-category-item]').forEach(item => {
            const show = groupMatches || matches(`${group.dataset.searchLabel || ''} ${item.dataset.searchLabel || ''}`, terms);
            item.hidden = !show;
            if (show) childMatches += 1;
          });
          group.hidden = !groupMatches && childMatches === 0;
          if (!group.hidden) visible += 1;
          if (group.tagName === 'DETAILS') group.open = query ? !group.hidden : originalStates.get(group);
        });
        azItems.forEach(item => {
          item.hidden = !matches(item.dataset.searchLabel || '', terms);
          if (!item.hidden) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
        if (clear) clear.hidden = !query;
      };
      input?.addEventListener('input', filter);
      input?.addEventListener('search', filter);
      input?.addEventListener('keydown', event => { if (event.key === 'Enter') event.preventDefault(); });
      clear?.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
      const menu = root.closest('.bpr-departments');
      if (menu) {
        const position = () => { if (menu.open) root.style.setProperty('--bpr-menu-top', `${Math.max(0, menu.querySelector('summary').getBoundingClientRect().bottom)}px`); };
        menu.addEventListener('toggle', () => { if (menu.open) { position(); if (window.matchMedia('(min-width: 901px)').matches) input?.focus({ preventScroll: true }); } });
        root.querySelector('[data-bpr-category-close]')?.addEventListener('click', () => { menu.open = false; menu.querySelector('summary').focus(); });
        window.addEventListener('resize', position, { passive: true });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
